"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _Detail = _interopRequireDefault(require("./components/Detail"));
var _Progress = _interopRequireDefault(require("@/components/Progress"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Detail: _Detail.default,
    Progress: _Progress.default
  },
  data: function data() {
    return {
      pageName: 'salesArea',
      formLabelWidth: '120px',
      region: '',
      city: '',
      area: '',
      regionOptions: [],
      cityOptions: [],
      areaOptions: [],
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      form: {
        file: null
      },
      searchVal: {
        shipTo: '',
        empNo: '',
        empName: '',
        regionCode: [],
        cityCode: [],
        districtCode: [],
        email: ''
      },
      isError: '',
      isShowModel: false,
      isShowProgress: false,
      excelBatchId: '',
      fileImportProcessUniqueCode: '',
      showClose: false,
      showResult: false,
      confirmText: '',
      props: {
        multiple: true,
        checkStrictly: true,
        value: 'value'
      }
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
    this.fetchRegionList();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          empNo: this.searchVal.empNo,
          empName: this.searchVal.empName,
          regionCode: this.searchVal.regionCode,
          cityCode: this.searchVal.cityCode,
          districtCode: this.searchVal.districtCode,
          email: this.searchVal.email
        }
      };
      this.listLoading = true;
      this.$api.salesArea.getList(param, this.sourceApi.token).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    handleEnd: function handleEnd() {
      this.searchData();
    },
    downloadExcel: function downloadExcel(name) {
      var _this2 = this;
      var param = {
        empNo: this.searchVal.empNo,
        empName: this.searchVal.empName,
        cityCode: this.searchVal.cityCode,
        regionCode: this.searchVal.regionCode,
        districtCode: this.searchVal.districtCode
      };
      this.isLoading = true;
      this.$api.salesArea.export(param).then(function (res) {
        _this2.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this2.isLoading = false;
      });
    },
    uploadData: function uploadData(file, fileList) {
      var _this3 = this;
      // 数据状态初始化
      this.confirmText = this.$t('common.confirm');
      var rawFile = file.raw;
      if (!rawFile) return;
      if (rawFile.size > 100 * 1024 * 1024) {
        this.$message.error('The file size cannot exceed 100M');
        return;
      }
      this.isLoading = true;
      var param = new FormData();
      param.append('file', rawFile);
      this.$api.salesArea.import(param).then(function (res) {
        _this3.isLoading = false;
        _this3.isShowProgress = true;
        _this3.excelBatchId = res.data.excelBatchId;
        _this3.fileImportProcessUniqueCode = res.data.redisKey;
        _this3.showClose = true;
        _this3.$nextTick(function () {
          _this3.$refs['progress'].start();
        });
      }).catch(function (res) {
        _this3.isLoading = false;
      });
    },
    fetchRegionList: function fetchRegionList() {
      var _this4 = this;
      if (this.$store.getters.regionData.length) {
        this.regionOptions = this.$store.getters.regionData;
        return;
      }
      this.$api.common.getRegionList(3).then(function (response) {
        var responseData = response;
        if (responseData.success) {
          _this4.regionOptions = responseData.data;
          _this4.$store.dispatch('baseData/saveRegionData', responseData.data);
        }
      }).catch(function (error) {
        console.log('-----' + error);
      });
    },
    resetData: function resetData() {
      this.searchVal = this.$options.data().searchVal;
      this.region = [];
      this.city = [];
      this.area = [];
      this.fetchData();
    },
    regionSearchChangeEvent: function regionSearchChangeEvent(value) {
      if (!value) return;
      var regionCode = [];
      var cityCode = [];
      var districtCode = [];
      value.forEach(function (item) {
        if (item.length === 1) {
          regionCode = regionCode.concat(item[0]);
        }
        if (item.length === 2) {
          cityCode = cityCode.concat(item[1]);
        }
        if (item.length === 3) {
          districtCode = districtCode.concat(item[2]);
        }
      });
      this.searchVal.regionCode = regionCode;
      this.searchVal.cityCode = cityCode;
      this.searchVal.districtCode = districtCode;
    },
    downloadResultExcel: function downloadResultExcel(name) {
      var _this5 = this;
      this.isLoading = true;
      this.$api.common.downloadResultExcel(this.excelBatchId).then(function (res) {
        _this5.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this5.isLoading = false;
      });
    },
    handleClickConfirm: function handleClickConfirm() {
      if (this.confirmText === this.$t('common.checkResult')) {
        this.isShowProgress = false;
        this.isShowModel = true;
      } else {
        this.isShowProgress = false;
      }
    },
    handleError: function handleError() {
      this.confirmText = this.$t('common.checkResult');
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    pcdClearEvent: function pcdClearEvent() {
      this.region = [];
      this.city = '';
      this.area = '';
      this.cityOptions = [];
      this.areaOptions = [];
      this.searchVal.rtlRegionList = [];
      this.searchVal.rtlDistrictList = [];
      this.searchVal.rtlCityList = [];
    },
    pcdChangeEvent: function pcdChangeEvent(value) {
      var rtlRegionList = [];
      var rtlCityList = [];
      var rtlDistrictList = [];
      while (value.some(function (item) {
        console.log(item);
        if (item.length === 3) {
          if (rtlRegionList.indexOf(item[0]) === -1) {
            rtlRegionList.push(item[0]);
          }
          if (rtlCityList.indexOf(item[1]) === -1) {
            rtlCityList.push(item[1]);
          }
          if (rtlDistrictList.indexOf(item[2]) === -1) {
            rtlDistrictList.push(item[2]);
          }
        }
        // eslint-disable-next-line no-empty
      })) {}
      this.searchVal.regionCode = rtlRegionList;
      this.searchVal.cityCode = rtlCityList;
      this.searchVal.districtCode = rtlDistrictList;
      console.log('=====val=====', value);
      // this.searchVal.rtlDistrictList = value
    },
    provinceChangeEvent: function provinceChangeEvent(value) {
      this.searchVal.regionCode = [].concat(value.value);
      if (value.children && value.children.length > 0) {
        this.cityOptions = (0, _toConsumableArray2.default)(value.children);
      }
    },
    cityChangeEvent: function cityChangeEvent(value) {
      this.searchVal.cityCode = [].concat(value.value);
      if (value.children && value.children.length > 0) {
        this.areaOptions = (0, _toConsumableArray2.default)(value.children);
      }
    },
    areaChangeEvent: function areaChangeEvent(value) {
      while (value.some(function (item) {
        return Array.isArray(item);
      })) {
        value = [].concat.apply([], value);
      }
      this.searchVal.districtCode = value;
    },
    provinceClearEvent: function provinceClearEvent() {
      this.city = '';
      this.area = '';
      this.cityOptions = [];
      this.areaOptions = [];
      this.searchVal.regionCode = [];
      this.searchVal.districtCode = [];
      this.searchVal.cityCode = [];
    },
    cityClearEvent: function cityClearEvent() {
      this.area = '';
      this.areaOptions = [];
      this.searchVal.districtCode = [];
    },
    areaClearEvent: function areaClearEvent() {
      this.searchVal.districtCode = [];
    },
    syncData: function syncData() {
      var _this6 = this;
      this.$api.salesArea.syncData({}).then(function (res) {
        if (res.success) {
          _this6.$message.success(_this6.$t('salesArea.message.syncSuccess'));
        } else {
          _this6.$message.error(_this6.$t('salesArea.message.syncFail'));
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    downloadRegionExcel: function downloadRegionExcel(name) {
      var _this7 = this;
      this.isLoading = true;
      this.$api.salesArea.exportRegion({}).then(function (res) {
        _this7.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this7.isLoading = false;
      });
    }
  }
};